[
  {
    "code": "FR-ARA-01",
    "name": "Ain"
  },
  {
    "code": "FR-HDF-02",
    "name": "Aisne"
  },
  {
    "code": "FR-ARA-03",
    "name": "Allier"
  },
  {
    "code": "FR-PAC-04",
    "name": "Alpes-de-Haute-Provence"
  },
  {
    "code": "FR-PAC-06",
    "name": "Alpes-Maritimes"
  },
  {
    "code": "FR-GES-08",
    "name": "Ardennes"
  },
  {
    "code": "FR-ARA-07",
    "name": "Ardèche"
  },
  {
    "code": "FR-OCC-09",
    "name": "Ariège"
  },
  {
    "code": "FR-GES-10",
    "name": "Aube"
  },
  {
    "code": "FR-OCC-11",
    "name": "Aude"
  },
  {
    "code": "FR-OCC-12",
    "name": "Aveyron"
  },
  {
    "code": "FR-GES-67",
    "name": "Bas-Rhin"
  },
  {
    "code": "FR-PAC-13",
    "name": "Bouches-du-Rhône"
  },
  {
    "code": "FR-NOR-14",
    "name": "Calvados"
  },
  {
    "code": "FR-ARA-15",
    "name": "Cantal"
  },
  {
    "code": "FR-NAQ-16",
    "name": "Charente"
  },
  {
    "code": "FR-NAQ-17",
    "name": "Charente-Maritime"
  },
  {
    "code": "FR-CVL-18",
    "name": "Cher"
  },
  {
    "code": "FR-NAQ-19",
    "name": "Corrèze"
  },
  {
    "code": "FR-COR-2A",
    "name": "Corse-du-Sud"
  },
  {
    "code": "FR-NAQ-23",
    "name": "Creuse"
  },
  {
    "code": "FR-BFC-21",
    "name": "Côte-d'Or"
  },
  {
    "code": "FR-BRE-22",
    "name": "Côtes-d'Armor"
  },
  {
    "code": "FR-NAQ-79",
    "name": "Deux-Sèvres"
  },
  {
    "code": "FR-NAQ-24",
    "name": "Dordogne"
  },
  {
    "code": "FR-BFC-25",
    "name": "Doubs"
  },
  {
    "code": "FR-ARA-26",
    "name": "Drôme"
  },
  {
    "code": "FR-IDF-91",
    "name": "Essonne"
  },
  {
    "code": "FR-NOR-27",
    "name": "Eure"
  },
  {
    "code": "FR-CVL-28",
    "name": "Eure-et-Loir"
  },
  {
    "code": "FR-BRE-29",
    "name": "Finistère"
  },
  {
    "code": "FR-OCC-30",
    "name": "Gard"
  },
  {
    "code": "FR-OCC-32",
    "name": "Gers"
  },
  {
    "code": "FR-NAQ-33",
    "name": "Gironde"
  },
  {
    "code": "FR-GES-68",
    "name": "Haut-Rhin"
  },
  {
    "code": "FR-COR-2B",
    "name": "Haute-Corse"
  },
  {
    "code": "FR-OCC-31",
    "name": "Haute-Garonne"
  },
  {
    "code": "FR-ARA-43",
    "name": "Haute-Loire"
  },
  {
    "code": "FR-GES-52",
    "name": "Haute-Marne"
  },
  {
    "code": "FR-ARA-74",
    "name": "Haute-Savoie"
  },
  {
    "code": "FR-BFC-70",
    "name": "Haute-Saône"
  },
  {
    "code": "FR-NAQ-87",
    "name": "Haute-Vienne"
  },
  {
    "code": "FR-PAC-05",
    "name": "Hautes-Alpes"
  },
  {
    "code": "FR-OCC-65",
    "name": "Hautes-Pyrénées"
  },
  {
    "code": "FR-IDF-92",
    "name": "Hauts-de-Seine"
  },
  {
    "code": "FR-OCC-34",
    "name": "Hérault"
  },
  {
    "code": "FR-BRE-35",
    "name": "Ille-et-Vilaine"
  },
  {
    "code": "FR-CVL-36",
    "name": "Indre"
  },
  {
    "code": "FR-CVL-37",
    "name": "Indre-et-Loire"
  },
  {
    "code": "FR-ARA-38",
    "name": "Isère"
  },
  {
    "code": "FR-BFC-39",
    "name": "Jura"
  },
  {
    "code": "FR-NAQ-40",
    "name": "Landes"
  },
  {
    "code": "FR-CVL-41",
    "name": "Loir-et-Cher"
  },
  {
    "code": "FR-ARA-42",
    "name": "Loire"
  },
  {
    "code": "FR-PDL-44",
    "name": "Loire-Atlantique"
  },
  {
    "code": "FR-CVL-45",
    "name": "Loiret"
  },
  {
    "code": "FR-OCC-46",
    "name": "Lot"
  },
  {
    "code": "FR-NAQ-47",
    "name": "Lot-et-Garonne"
  },
  {
    "code": "FR-OCC-48",
    "name": "Lozère"
  },
  {
    "code": "FR-PDL-49",
    "name": "Maine-et-Loire"
  },
  {
    "code": "FR-NOR-50",
    "name": "Manche"
  },
  {
    "code": "FR-GES-51",
    "name": "Marne"
  },
  {
    "code": "FR-PDL-53",
    "name": "Mayenne"
  },
  {
    "code": "FR-GES-54",
    "name": "Meurthe-et-Moselle"
  },
  {
    "code": "FR-GES-55",
    "name": "Meuse"
  },
  {
    "code": "FR-BRE-56",
    "name": "Morbihan"
  },
  {
    "code": "FR-GES-57",
    "name": "Moselle"
  },
  {
    "code": "FR-BFC-58",
    "name": "Nièvre"
  },
  {
    "code": "FR-HDF-59",
    "name": "Nord"
  },
  {
    "code": "FR-HDF-60",
    "name": "Oise"
  },
  {
    "code": "FR-NOR-61",
    "name": "Orne"
  },
  {
    "code": "FR-IDF-75C",
    "name": "Paris"
  },
  {
    "code": "FR-HDF-62",
    "name": "Pas-de-Calais"
  },
  {
    "code": "FR-ARA-63",
    "name": "Puy-de-Dôme"
  },
  {
    "code": "FR-NAQ-64",
    "name": "Pyrénées-Atlantiques"
  },
  {
    "code": "FR-OCC-66",
    "name": "Pyrénées-Orientales"
  },
  {
    "code": "FR-ARA-69",
    "name": "Rhône"
  },
  {
    "code": "FR-PDL-72",
    "name": "Sarthe"
  },
  {
    "code": "FR-ARA-73",
    "name": "Savoie"
  },
  {
    "code": "FR-BFC-71",
    "name": "Saône-et-Loire"
  },
  {
    "code": "FR-IDF-77",
    "name": "Seine-et-Marne"
  },
  {
    "code": "FR-NOR-76",
    "name": "Seine-Maritime"
  },
  {
    "code": "FR-IDF-93",
    "name": "Seine-Saint-Denis"
  },
  {
    "code": "FR-HDF-80",
    "name": "Somme"
  },
  {
    "code": "FR-OCC-81",
    "name": "Tarn"
  },
  {
    "code": "FR-OCC-82",
    "name": "Tarn-et-Garonne"
  },
  {
    "code": "FR-BFC-90",
    "name": "Territoire de Belfort"
  },
  {
    "code": "FR-IDF-95",
    "name": "Val-d'Oise"
  },
  {
    "code": "FR-IDF-94",
    "name": "Val-de-Marne"
  },
  {
    "code": "FR-PAC-83",
    "name": "Var"
  },
  {
    "code": "FR-PAC-84",
    "name": "Vaucluse"
  },
  {
    "code": "FR-PDL-85",
    "name": "Vendée"
  },
  {
    "code": "FR-NAQ-86",
    "name": "Vienne"
  },
  {
    "code": "FR-GES-88",
    "name": "Vosges"
  },
  {
    "code": "FR-BFC-89",
    "name": "Yonne"
  },
  {
    "code": "FR-IDF-78",
    "name": "Yvelines"
  }
]